module.exports = __webpack_public_path__ + "img/Suiyin.75e22474.png";